import { useEffect, useState } from "react";
import QRCode from "qrcode";

/* Renders a QR code LOCALLY.
 *
 * This used to call quickchart.io with the link as a query parameter — which
 * meant every team's magic link, passcode included, was sent to a third party
 * on every render, and sat in their request logs. Those passcodes ARE the auth
 * for this app, and they unlock availability data for children.
 *
 * Generating in-browser means the passcode never leaves the device, and the
 * codes keep working if that service is down or blocked. */
export function QrCode({ value, size = 120, className = "", alt = "QR code" }) {
  const [dataUrl, setDataUrl] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!value) return;
    QRCode.toDataURL(value, { width: size, margin: 1, errorCorrectionLevel: "M" })
      .then((url) => !cancelled && setDataUrl(url))
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
    };
  }, [value, size]);

  if (failed) {
    return (
      <div className={`flex items-center justify-center bg-gray-50 text-[10px] text-gray-400 ${className}`}>
        QR unavailable
      </div>
    );
  }
  // Placeholder keeps the layout from jumping while it renders.
  if (!dataUrl) return <div className={`bg-gray-100 animate-pulse ${className}`} />;
  return <img src={dataUrl} alt={alt} className={className} />;
}
